import { render, staticRenderFns } from "./vistaCalendario.vue?vue&type=template&id=49b97124&scoped=true"
import script from "./vistaCalendario.vue?vue&type=script&lang=js"
export * from "./vistaCalendario.vue?vue&type=script&lang=js"
import style0 from "./vistaCalendario.vue?vue&type=style&index=0&id=49b97124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b97124",
  null
  
)

export default component.exports